import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _ItemFeedbackModal;
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Button, CloseButton } from '@instructure/ui-buttons';
import { Heading } from '@instructure/ui-heading';
import { jsx } from '@instructure/emotion';
import { RichContentRenderer, RichContentInput, RCE_THREE_LINES_HEIGHT } from '@instructure/quiz-rce';
import t from '@instructure/quiz-i18n/format-message';
import { Modal, ModalHeader, ModalBody, ModalFooter, ITEM_FEEDBACK_MODAL_FEEDBACK, XSMALL_SIDE_MARGIN, withStyleOverrides } from '@instructure/quiz-common';
import generateStyle from './styles';
import generateComponentTheme from './theme';
export var ItemFeedbackModal = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_ItemFeedbackModal = /*#__PURE__*/function (_Component) {
  function ItemFeedbackModal() {
    var _this2;
    _classCallCheck(this, ItemFeedbackModal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, ItemFeedbackModal, [].concat(args));
    _defineProperty(_this2, "onFeedbackChange", function (key, content) {
      var newFeedback = _this2.props.feedback.set(key, content);
      _this2.props.setUi(ITEM_FEEDBACK_MODAL_FEEDBACK, newFeedback);
    });
    _defineProperty(_this2, "onFeedbackWrapper", function (key) {
      return function (_, map) {
        return _this2.onFeedbackChange(key, map.editorContent);
      };
    });
    _defineProperty(_this2, "continueAction", function () {
      _this2.props.changeItemFeedback(_this2.props.item.id, _this2.props.feedback);
      _this2.closeAction();
    });
    _defineProperty(_this2, "closeAction", function () {
      _this2.props.modalTrigger && _this2.props.modalTrigger.focus();
      _this2.props.closeModal();
    });
    return _this2;
  }
  _inherits(ItemFeedbackModal, _Component);
  return _createClass(ItemFeedbackModal, [{
    key: "cancelButton",
    value: function cancelButton() {
      return jsx(Button, {
        onClick: this.closeAction,
        margin: XSMALL_SIDE_MARGIN,
        "data-automation": "sdk-item-feedback-modal-cancel-button"
      }, t('Cancel'));
    }
  }, {
    key: "doneButton",
    value: function doneButton() {
      return jsx(Button, {
        color: "primary",
        onClick: this.continueAction,
        margin: XSMALL_SIDE_MARGIN,
        "data-automation": "sdk-item-feedback-modal-done-button"
      }, t('Done'));
    }
  }, {
    key: "renderRichContentInput",
    value: function renderRichContentInput(key, label) {
      return jsx("div", null, jsx("br", null), jsx("label", {
        css: this.props.styles.feedbackLabel,
        htmlFor: key
      }, label), jsx(RichContentInput, {
        label: "",
        textareaId: key,
        defaultContent: this.props.feedback.get(key),
        onChange: this.onFeedbackWrapper(key),
        height: RCE_THREE_LINES_HEIGHT
      }));
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      return jsx("div", null, jsx(RichContentRenderer, {
        customStyles: this.props.styles.itemStem,
        content: this.props.item.itemBody
      }), this.renderRichContentInput('correct', t('For a correct answer')), this.renderRichContentInput('incorrect', t('For an incorrect answer')), this.renderRichContentInput('neutral', t('Provide general feedback (regardless of answer)')));
    }
  }, {
    key: "render",
    value: function render() {
      return jsx("div", null, jsx(Modal, {
        open: this.props.modalOpen || this.props.importModalOpen,
        onClose: this.closeAction,
        size: "large",
        label: t('Student Feedback'),
        shouldCloseOnDocumentClick: false // must be false to allow interacting with RCE modals (such as embed media)
        ,
        shouldReturnFocus: false
      }, jsx(ModalHeader, null, jsx(Heading, {
        level: "reset",
        as: "h2"
      }, t('Student Feedback')), jsx(CloseButton, {
        onClick: this.closeAction,
        placement: "end",
        offset: "medium",
        screenReaderLabel: t('Close')
      })), jsx(ModalBody, null, this.renderContent()), jsx(ModalFooter, null, this.cancelButton(), this.doneButton())));
    }
  }]);
}(Component), _defineProperty(_ItemFeedbackModal, "displayName", 'ItemFeedbackModal'), _defineProperty(_ItemFeedbackModal, "componentId", "Quizzes".concat(_ItemFeedbackModal.displayName)), _defineProperty(_ItemFeedbackModal, "propTypes", {
  changeItemFeedback: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  feedback: ImmutablePropTypes.map.isRequired,
  importModalOpen: PropTypes.bool.isRequired,
  item: ImmutablePropTypes.record.isRequired,
  modalOpen: PropTypes.bool.isRequired,
  setUi: PropTypes.func.isRequired,
  modalTrigger: PropTypes.instanceOf(Component),
  styles: PropTypes.object
}), _defineProperty(_ItemFeedbackModal, "defaultProps", {
  modalTrigger: null
}), _ItemFeedbackModal)) || _class);
export default ItemFeedbackModal;